import { FormatNumberOptions, IntlShape, MessageDescriptor } from 'react-intl';

class IntlService {
  private static instance: IntlService;
  private intl: IntlShape | null = null;
  private initPromise: Promise<IntlShape>;
  private resolveInit!: (intl: IntlShape) => void;

  static getInstance(): IntlService {
    if (!IntlService.instance) {
      IntlService.instance = new IntlService();
    }
    return IntlService.instance;
  }

  constructor() {
    this.initPromise = new Promise((resolve) => {
      this.resolveInit = resolve;
    });
  }

  init(intl: IntlShape) {
    this.intl = intl;
    this.resolveInit(intl);
  }

  getIntl(): IntlShape {
    if (!this.intl) {
      throw new Error('IntlService is not initialized.');
    }
    return this.intl;
  }

  isInitialized(): boolean {
    return this.intl !== null;
  }

  formatMessage(
    messageDescriptor: MessageDescriptor,
    values?: Record<string, any>,
  ) {
    return async () => {
      const intl = this.intl || (await this.initPromise);
      return intl.formatMessage(messageDescriptor, values);
    };
  }

  formatNumber(value: number, options?: FormatNumberOptions) {
    return async () => {
      const intl = this.intl || (await this.initPromise);
      return intl.formatNumber(value, options);
    };
  }

  reset() {
    this.intl = null;
  }
}

export const intlService = IntlService.getInstance();
